import { render, staticRenderFns } from "./DelimitedList.vue?vue&type=template&id=dc9dfdd2"
import script from "./DelimitedList.vue?vue&type=script&lang=js"
export * from "./DelimitedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports